import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: "history",
	routes: [{ // 登陆
			path: '/',
			name: '登录',
			component: () =>
				import("@/components/Login")
		},
		{
			path: '/index',
			name: '监视预警',
			component: () =>
				import("@/components/HomeIndex/homeIndex")
		},
		{
			path: '/floodSituationMap',
			name: '防汛形势图',
			component: () =>
				import("@/components/map/mapCpts/floodSituationMap")
		},
		{
			path: '/workbench',
			name: '工作台',
			component: () =>
				import("@/components/workbench/index"),
			redirect: '/workbench/rainInfo',
			children: [{
				path: 'rainInfo',
				name: '雨水情及预警信息',
				component: () =>
					import("@/components/workbench/indexComponents/raininfo/main")
			}]
		},
		{
			path: '/movePatrol',
			name: '移动巡查',
			component: () =>
				import("@/components/movePatrol/movePatrolIndex"),
		},
		{
			path: '/floodControlInfo',
			name: '防汛信息',
			component: () =>
				import("@/components/floodControlInfo/index"),
			children: [{
				path: 'Fxzrr',
				name: '防汛责任人',
				component: () =>
					import('@/components/floodControlInfo/indexComponents/mainComponents/fxzrr')
			}, {
				path: 'Fxbm',
				name: '防汛部门',
				component: () =>
					import('@/components/floodControlInfo/indexComponents/mainComponents/fxbm')
			}, {
				path: 'AdPlan',
				name: '防洪预案',
				component: () =>
					import('@/components/floodControlInfo/indexComponents/mainComponents/adPlan')
			}]
		},
		{
			path: '/comprehensive',
			name: '综合查询',
			component: () =>
				import("@/components/DiaoCha/DiaochaIndex"),
			children: [{
					path: 'warnlist',
					name: '预警信息',
					component: () =>
						import("@/components/DiaoCha/indexComponents/mainComponents/warnList"),
				}, {
					path: 'warnComplex',
					name: '预警信息',
					component: () =>
						import("@/components/DiaoCha/indexComponents/mainComponents/WarnComplex"),
				}, {
					path: 'relaInfo',
					name: '综合展示',
					component: () =>
						import("@/components/DiaoCha/indexComponents/mainComponents/relaInfo")
				},
				{
					path: 'soilMoisture',
					name: '墒情',
					component: () =>
						import("@/components/DiaoCha/indexComponents/mainComponents/soilMoisture")
				},
				//-----------分析评价----------------
				{
					path: 'Zuixinyuqing',
					name: '最新雨情',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/yuqingxinxi/Zuixinyuqing')
				}, {
					path: 'RainQuery',
					name: '降水量查询统计',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/yuqingxinxi/RainQuery')
				}, {
					path: 'MaximumRain',
					name: '分类最大降雨统计',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/yuqingxinxi/MaximumRain')
				}, {
					path: 'TorrentRainSta',
					name: '暴雨强度统计',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/yuqingxinxi/TorrentRainSta')
				}, {
					path: 'ShortDurationRain',
					name: '短历时强降雨统计',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/yuqingxinxi/ShortDurationRain')
				},

				{
					path: 'XYRainSta',
					name: '旬月雨量统计',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/yuqingxinxi/XYRainSta')
				}, {
					path: 'YearRainSta',
					name: '年雨量统计',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/yuqingxinxi/YearRainSta')
				}, {
					path: 'sqHd',
					name: '最新河道水情',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/sqHd')
				}, {
					path: 'riverQuery',
					name: '河道水情查询',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/riverQuery')
				}, {
					path: 'riverJZ',
					name: '河道水位极值',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/riverJZ')
				}, {
					path: 'sqSk',
					name: '最新水库水情',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/sqSk')
				}, {
					path: 'rsvrQuery',
					name: '水库水情查询',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/rsvrQuery')
				}, {
					path: 'liuyuSq',
					name: '流域水情查询',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/liuyuSq')
				}, {
					path: 'rsvrJZ',
					name: '水库水位极值',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/rsvrJZ')
				}, {
					path: 'dxskSq',
					name: '大型水库水情',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/dxskSq')
				}, {
					path: 'xxskSq',
					name: '中型水库水情',
					component: () =>
						import('@/components/DiaoCha/indexComponents/mainComponents/Shuiyuqingxinxi/shuiqingxinxi/xxskSq')
				},
				{
					path: 'MountainSpaper',
					name: '山洪快报',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/MountainSpaper/MountainSpaper')
				}, {
					path: 'waterRainWork',
					name: '防办水雨工情',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/waterRainWork/waterRainWork')
				},
				{
					path: 'floodInformation',
					name: '汛情通报',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/floodInformation/floodInformation')
				},
				{
					path: 'ImgStation',
					name: '图像站',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/jichuxinxi/imgStation')
				}, {
					path: 'VideoStation',
					name: '视频站',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/jichuxinxi/videoStation')
				},

				{
					path: 'EquipmentRun',
					name: '设备运行情况',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/jichuxinxi/equipmentRun')
				},
				{
					path: 'StBreakdown',
					name: '测站故障统计',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/jichuxinxi/stBreakdown')
				},
				//工情信息
				{
					path: 'Sluice',
					name: '水闸',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/gongqing/sluice')
				},
				{
					path: 'Pumpstation',
					name: '泵站',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/gongqing/pumpstation')
				},
				{
					path: 'Reservoir',
					name: '水库',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/gongqing/reservoir')
				},
				{
					path: 'River',
					name: '河流',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/gongqing/river')
				},{
					path: 'waterRecord1',
					name: '水情记载表(一)',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/waterRecord1')
				},{
					path: 'waterRecord2',
					name: '水情记载表(二)',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/waterRecord2')
				},{
					path: 'gateMonitoringData',
					name: '水闸监测数据',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/gateMonitoringData')
				},{
					path: 'pumpMonitoringData',
					name: '泵站监测数据',
					component: () =>
						import('@/components/Diaocha/indexComponents/mainComponents/pumpMonitoringData')
				},
				{
					path: 'iframe',
					name: 'iframe嵌入',
					component: () =>
						import('@/components/publicComponents/iframe')
				},
				{
					path: 'blank',
					name: '弹出页面',
					component: () =>
						import('@/components/publicComponents/blank')
				}
			]
		},
		{
			path: '/surveyResult',
			name: '调查成果',
			component: () =>
				import('@/components/surveyResult/index'),
			children: [{
					path: 'Zongduanmian',
					name: '沟道纵断面',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/goudaoxinxi/Zongduanmian')
				},
				{
					path: 'Hengduanmian',
					name: '沟道横断面',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/goudaoxinxi/Hengduanmian')
				},
				{
					path: 'jichuqingkuang',
					name: '基础情况统计',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/jichuxinxi/JichuqingKuang')
				},
				{
					path: 'zqjichuqingkuang',
					name: '基础情况统计',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/jichuxinxi/zqjichuqingkuang')
				},
				{
					path: 'zongtiqingkuang',
					name: '行政区划总体情况',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/jichuxinxi/ZongtiQingkuang')
				},
				{
					path: 'Jingjiqingkuang',
					name: '社会经济情况',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/jichuxinxi/Jingjiqingkuang')
				},
				{
					path: 'mediumsmallrivers',
					name: '中小河流现状防洪能力统计',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/jichuxinxi/mediumsmallrivers')
				},
				{
					path: 'Liuyujibenxinxi',
					name: '小流域基本信息',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/liuyuxinxi/Liuyujibenxinxi')
				},
				{
					path: 'Fangzhijiben',
					name: '防治区基本情况',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/fangzhiheweixian/Fangzhijiben')
				},
				{
					path: 'Weixianjiben',
					name: '低洼易涝区基本情况',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/fangzhiheweixian/Weixianjiben')
				},
				{
					path: 'waihongweixiequ',
					name: '外洪威胁区基本情况',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/fangzhiheweixian/waihongweixiequ')
				},
				{
					path: 'Fangzhiquqishiyedanwei',
					name: '防治区企事业单位',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/fangzhiheweixian/Fangzhiquqishiyedanwei')
				},
				{
					path: 'Xuzhilifanghonggou',
					name: '需防洪治理山洪沟',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/fangzhiheweixian/Xuzhilifanghonggou')
				},
				{
					path: 'Zhongyaochengzhenjumin',
					name: '重要城镇居民',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/fangzhiheweixian/Zhongyaochengzhenjumin')
				},
				{
					path: 'Yanhecunluo',
					name: '重要沿河村落居民',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/fangzhiheweixian/Yanhecunluo')
				},
				{
					path: 'Lishishanhong',
					name: '历史山洪灾害情况',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/Lishishanhong/Lishishanhongzaihaiqingkuang')
				},
				{
					path: 'Zidongyuliangzhan',
					name: '自动雨量站',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/shebeixinxi/Zidongyuliangzhan')
				},
				{
					path: 'Hedaoshuiweizhan',
					name: '河道水位站',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/shebeixinxi/Hedaoshuiweizhan')
				},
				{
					path: 'Shuikushuiweizhan',
					name: '水库水位站',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/shebeixinxi/Shuikushuiweizhan')
				},
				{
					path: 'Wuxianyujingguangbozhan',
					name: '无线预警广播站',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/shebeixinxi/Wuxianyujingguangbozhan')
				},
				{
					path: 'Shuiku',
					name: '水库',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/sheshuigongcheng/Shuiku')
				},
				{
					path: 'Shuizha',
					name: '水闸',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/sheshuigongcheng/Shuizha')
				},
				{
					path: 'Difang',
					name: '堤防',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/sheshuigongcheng/Difang')
				},
				{
					path: 'Tangyanba',
					name: '塘（堰）坝',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/sheshuigongcheng/Tangyanba')
				},
				{
					path: 'Luhan',
					name: '路涵',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/sheshuigongcheng/Luhan')
				},
				{
					path: 'Qiaoliang',
					name: '桥梁',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/sheshuigongcheng/Qiaoliang')
				},
				{
					path: 'Benzhan',
					name: '泵站',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/sheshuigongcheng/Benzhan')
				},{
					path: 'Jianyishuiweizhan',
					name: '简易水位站',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/shebeixinxi/Jianyishuiweizhan')
				}, {
					path: 'Jianyiyuliangzhan',
					name: '简易雨量站',
					component: () =>
						import('@/components/surveyResult/indexComponents/mainComponents/shebeixinxi/Jianyiyuliangzhan')
				}
			]
		},
		{
			path: '/analyticalEvaluation',
			name: '分析评价',
			component: () =>
				import('@/components/analyticalEvaluation/index'),
			children: [{
				path: 'fxSjby',
				name: '设计暴雨',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxSjby')
			}, {
				path: 'fxXlyhlsj',
				name: '小流域汇流时间设计暴雨',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxXlyhlsj')
			}, {
				path: 'fxKzdmsjhs',
				name: '控制断面设计洪水',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxKzdmsjhs')
			}, {
				path: 'fxKzdmswllrk',
				name: '控制断面水位流量人口关系',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxKzdmswllrk')
			}, {
				path: 'fxFhxz',
				name: '防洪现状评价',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxFhxz')
			}, {
				path: 'fxLjyljygz',
				name: '临界雨量经验估计法成果',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxLjyljygz')
			}, {
				path: 'fxLjyljyfx',
				name: '临界雨量降雨分析法成果',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxLjyljyfx')
			}, {
				path: 'fxLjylmxfx',
				name: '临界雨量模型分析法',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxLjylmxfx')
			}, {
				path: 'fxYjzbsdyl',
				name: '预警指标时段雨量',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxYjzbsdyl')
			}, {
				path: 'fxYjzbzhyl',
				name: '预警指标综合雨量',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxYjzbzhyl')
			}, {
				path: 'fxYjzbsw',
				name: '预警指标水位',
				component: () =>
					import('@/components/analyticalEvaluation/indexComponents/mainComponents/fxYjzbsw')
			}]
		},
		{
			path: '/systemStration',
			name: '系统设置',
			component: () =>
				import('@/components/SystemStration/index'),
			children: [{
					path: 'userStration',
					name: '用户管理',
					component: () =>
						import('@/components/SystemStration/indexComponents/mainComponents/UserStration'),
				},
				{
					path: 'userGroup',
					name: '权限管理',
					component: () =>
						import('@/components/SystemStration/indexComponents/mainComponents/UserGroup'),
				},

				{
					path: 'keyUsers',
					name: '重点动能用户',
					component: () =>
						import('@/components/SystemStration/indexComponents/mainComponents/keyUsers'),
				},
				{
					path: 'logManage',
					name: '日志管理',
					component: () =>
						import('@/components/SystemStration/indexComponents/mainComponents/logManage'),
				},
				{
					path: 'iframe',
					name: 'iframe嵌入',
					component: () =>
						import('@/components/publicComponents/iframe')
				},
				{
					path: 'blank',
					name: '弹出页面',
					component: () =>
						import('@/components/publicComponents/blank')
				}
			]
		},
		{
			path: '/dataManage',
			name: '数据管理',
			component: () =>
				import('@/components/dataManage/index'),
			children: [{
					path: 'stBasicInfo',
					name: '测站基本信息',
					component: () =>
						import('@/components/dataManage/indexComponents/stBasicInfo'),
				},{
					path: 'gpjBasicInfo',
					name: ' 图像站基本信息',
					component: () =>
						import('@/components/dataManage/indexComponents/gpjBasicInfo'),
				},{
					path: 'videoBasicInfo',
					name: '视频站基本信息',
					component: () =>
						import('@/components/dataManage/indexComponents/videoBasicInfo'),
				},
				{
					path: 'iframe',
					name: 'iframe嵌入',
					component: () =>
						import('@/components/publicComponents/iframe')
				},
				{
					path: 'blank',
					name: '弹出页面',
					component: () =>
						import('@/components/publicComponents/blank')
				}, {
					path: 'personB',
					name: '责任人管理',
					component: () =>
						import('@/components/dataManage/indexComponents/personB'),
				}, {
					path: 'floodPrevention',
					name: '防汛部门管理',
					component: () =>
						import('@/components/dataManage/indexComponents/floodPrevention'),
				},
				{
					path: 'planningManage',
					name: '预案管理',
					component: () =>
						import('@/components/dataManage/indexComponents/planningManage'),
				},
				{
					path: 'newsFlash',
					name: '山洪快报管理',
					component: () =>
						import('@/components/dataManage/indexComponents/newsFlash'),
				},
				{
					path: 'newsStation',
					name: '快报站点管理',
					component: () =>
						import('@/components/dataManage/indexComponents/newsStation'),
				},
				{
					path: 'rainWarningShan',
					name: '雨量预警指标-山洪',
					component: () =>
						import('@/components/dataManage/indexComponents/rainWarningShanhong'),
				},
				{
					path: 'waterWarningShan',
					name: '水位预警指标-山洪',
					component: () =>
						import('@/components/dataManage/indexComponents/waterWarningShan'),
				},
				{
					path: 'rainWarningDiao',
					name: '雨量预警指标-调查',
					component: () =>
						import('@/components/dataManage/indexComponents/rainWarningDiao'),
				},
				{
					path: 'waterWarningDiao',
					name: '水位预警指标-调查',
					component: () =>
						import('@/components/dataManage/indexComponents/waterWarningDiao'),
				},
				{
					path: 'warningOptions',
					name: '预警设置',
					component: () =>
						import('@/components/dataManage/indexComponents/warningOptions'),
				},
				{
					path: 'disasterPreventionObject',
					name: '防灾对象',
					component: () =>
						import('@/components/dataManage/indexComponents/disasterPreventionObject'),
				},
				{
					path: 'disasterPreventionObjectType',
					name: '防灾对象类型',
					component: () =>
						import('@/components/dataManage/indexComponents/disasterPreventionObjectType'),
				},
				{
					path: 'warnIndicators',
					name: '预警指标',
					component: () =>
						import('@/components/dataManage/indexComponents/warnIndicators'),
				},
				{
					path: 'focusAdSt',
					name: '关注站点管理',
					component: () =>
						import('@/components/dataManage/indexComponents/focusAdSt'),
				},
				{
					path: 'radioBroadcastManagement',
					name: '无线广播管理',
					component: () =>
						import('@/components/dataManage/indexComponents/radioBroadcastManagement'),
				},
				{
					path: 'wirelessVendorManagement',
					name: '广播厂商配置',
					component: () =>
						import('@/components/dataManage/indexComponents/wirelessVendorManagement'),
				},
				{
					path: 'bangzhanShuiqing',
					name: '泵站水情',
					component: () =>
						import('@/components/dataManage/indexComponents/bangzhanShuiqing'),
				},

				{
					path: 'zhamenqibiqingkuang',
					name: '闸门启闭情况',
					component: () =>
						import('@/components/dataManage/indexComponents/zhamenqibiqingkuang'),
				},

				{
					path: 'shuikuzhanshuju',
					name: '水库站数据',
					component: () =>
						import('@/components/dataManage/indexComponents/shuikuzhanshuju'),
				}
			]
		},
		{
			path: '/dutyManage',
			name: '值班信息',
			component: () =>
				import('@/components/dutyManage/index'),
			children: [{
					path: 'dutyLog',
					name: '值班日志',
					component: () =>
						import('@/components/dutyManage/indexComponents/mainComponents/dutyLog'),
				},
				{
					path: 'dutyPlan',
					name: '值班安排',
					component: () =>
						import('@/components/dutyManage/indexComponents/mainComponents/dutyPlan'),
				},
				{
					path: 'receiveFile',
					name: '收文管理',
					component: () =>
						import('@/components/dutyManage/indexComponents/mainComponents/receiveFile'),
				},
				{
					path: 'sendFile',
					name: '发文管理',
					component: () =>
						import('@/components/dutyManage/indexComponents/mainComponents/sendFile'),
				}, ,
				{
					path: 'iframe',
					name: 'iframe嵌入',
					component: () =>
						import('@/components/publicComponents/iframe')
				},
				{
					path: 'blank',
					name: '弹出页面',
					component: () =>
						import('@/components/publicComponents/blank')
				}
			]
		},
		//气象信息
		{
			path: '/weather',
			name: '气象信息',
			component: () =>
				import('@/components/weather/weatherIndex'),
			children: [{
					path: 'Weixingyuntu',
					name: '卫星云图',
					component: () =>
						import('@/components/weather/indexComponents/weixingyuntu')
				},
				{
					path: 'Zaihaiyujing',
					name: '灾害预警',
					component: () =>
						import('@/components/weather/indexComponents/zaihaiYujing')
				},
				{
					path: 'Duanshiyubao',
					name: '短时预报',
					component: () =>
						import('@/components/weather/indexComponents/duanshiyubao')
				},
				{
					path: 'Tianqiyubao',
					name: '天气预报',
					component: () =>
						import('@/components/weather/indexComponents/tianqiyubao')
				},
				{
					path: 'Leidatu',
					name: '雷达图',
					component: () =>
						import('@/components/weather/indexComponents/leidatu')
				},
				{
					path: 'iframe',
					name: 'iframe嵌入',
					component: () =>
						import('@/components/publicComponents/iframe')
				},
				{
					path: 'blank',
					name: '弹出页面',
					component: () =>
						import('@/components/publicComponents/blank')
				}
			]
		}
	]
});

//注册全局前置守卫  未登录或失去登录信息时 跳转到登录页面
router.beforeEach((to, from, next) => {
	if(to.path == "/") {
		next();
	} else {
		if(!localStorage.userInfo && !sessionStorage.information) {
			next("/");
		} else if(localStorage.userInfo && !sessionStorage.information) {
			sessionStorage.information = localStorage.userInfo;
		}
		next();
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js